import { useState,useEffect } from 'react'; 
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { Button, Stack } from '@mui/material';
import { ConstructionRounded } from '@mui/icons-material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { IMAGESERVICEURL } from './SinglePage';

const minDistance = 10;

//const baseurl = "http://localhost:8181/cxf/eyeprocessor/lastfastsam/image/";
//const IMAGESERVICEURL = "http://localhost:8181/cxf/eyeprocessor/";

function valuetext(value) {
    return `${value}px`;
  }

class Ellipsobj {
    constructor(valuex,valuey,dims) {
        this.cx=dims[0]*valuex[1]/100;
        this.rx=Math.abs(dims[0]*(valuex[1]-valuex[0])/100);
        this.cy=dims[1]-(dims[1]*valuey[1]/100);
        this.ry=Math.abs(dims[1]*(valuey[1]-valuey[0])/100);
    }
    
    
}

const CenterEditor = ({dim, show, callback}) => {
  
  const [valuex, setValuex] = useState([10, 50]);
  const [valuey, setValuey] = useState([10, 50]);
  const [dims, setDims] = useState([dim,dim]);

  const src = IMAGESERVICEURL+"lastfastsam/image/"+show;

  /*useEffect(()=>{
    Ellipsobj.cx=dim*valuex[1]/100;
    Ellipsobj.rx=Math.abs(dim*(valuex[1]-valuex[0])/100);
  },[valuex]);
  
  useEffect(()=>{
    Ellipsobj.cy=dim-(dim*valuey[0]/100);
    Ellipsobj.ry=Math.abs(dim*(valuey[1]-valuey[0])/100);
  },[valuey]);*/

  if(dim===undefined || show ===undefined){
    return (<></>);
  }
  const handleChangex = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    if (newValue[1] - newValue[0] < minDistance) {
        if (activeThumb === 0) {
          const clamped = Math.min(newValue[0], 100 - minDistance);
          setValuex([clamped, clamped + minDistance]);
        } else {
          const clamped = Math.max(newValue[1], minDistance);
          setValuex([clamped - minDistance, clamped]);
        }
      } else {
        setValuex(newValue);
      }
  };

  
  const scale = (val)=>{
    return dim*val/100;
  }

  const absdiff = (val)=>{
    return Math.abs(dim*(val[1]-val[0]))/100;
  }

  const handleChangey = (event, newValue, activeThumb) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    if (newValue[1] - newValue[0] < minDistance) {
      if (activeThumb === 0) {
        const clamped = Math.min(newValue[0], 100 - minDistance);
        setValuey([clamped, clamped + minDistance]);
      } else {
        const clamped = Math.max(newValue[1], minDistance);
        setValuey([clamped - minDistance, clamped]);
      }
    } else {
      setValuey(newValue);
    }
  };

  const committed = ()=>{
    console.log("committed");
  }

  const isSelected = (prop)=>{
    if (show===undefined)
        return 'none';
    return 'inline';
  }

  const showdim = (e)=>{
    console.log("dimensions "+e.target.naturalHeight+" x "+e.target.naturalWidth);
    setDims([e.target.naturalWidth,e.target.naturalHeight]);
  }

  const submit = (e)=>{
    //let img = document.getElementById("baseimg");
    
    callback(undefined); 
    fetch(IMAGESERVICEURL+"maskcenter/"+show,{
        method:"POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body:JSON.stringify(new Ellipsobj(valuex,valuey,dims))
    }).then((response)=> response.json())
    .then((data)=>{
        console.log("done"); 
        callback(show); 
    })
    .catch((error)=>{
        console.log("error "+error);
            
    });
  }

  //<ellipse id={"pippo"} cx={scale(valuex[1])} cy={dim-scale(valuey[1])} rx={absdiff(valuex)} ry={absdiff(valuey)} stroke="green" strokeWidth={3} fill={'transparent'}/>

  const svg = ()=>{
        return (
            <svg style={{display:'block', marginTop:-dim}} width={dim} height={dim}>
                <line stroke-dasharray="0 4 0" x1={scale(valuex[1])} y1={0} x2={scale(valuex[1])} y2={dim-scale(valuey[1])} stroke="yellow" />
                <line stroke-dasharray="0 4 0" y1={dim-scale(valuey[1])} x1={dim} y2={dim-scale(valuey[1])} x2={scale(valuex[1])} stroke="yellow" />
                <line stroke-dasharray="2 2 2" x1={scale(valuex[0])} y1={0} x2={scale(valuex[0])} y2={dim-scale(valuey[1])} stroke="green" />
                <line stroke-dasharray="2 2 2" y1={dim-scale(valuey[0])} x1={dim} y2={dim-scale(valuey[0])} x2={scale(valuex[1])} stroke="green" />
                
                <defs>
                    <mask id="hole">
                        <rect width={dim} height={dim} fill="white"/>
                        <ellipse id={"mask"} cx={scale(valuex[1])} cy={dim-scale(valuey[1])} rx={absdiff(valuex)} ry={absdiff(valuey)} strokeWidth={3} fill={'black'}/>
                    </mask>
                </defs>

                <rect width={dim} height={dim} mask="url(#hole)"/>
            </svg>
                
       ); 
    
  }
  //<img loading="lazy" style={{width:300,height:300}} src="http://localhost:8181/cxf/eyeprocessor/lastfastsam/image/0"/>
  return (
    <Box sx={{ width: dim }}>
      <Slider
        getAriaLabel={() => 'X'}
        value={valuex}
        onChange={handleChangex}
        onChangeCommitted={committed}
        valueLabelDisplay="auto"
        getAriaValueText={valuetext}
        disableSwap
      />
       <Stack sx={{ height: dim }} spacing={1} direction="row" >
         
        <div style={{display:'inline-block'}}>
                <img id="baseimg" onLoad={showdim} style={{display:'block',width:dim,height:dim}} loading="lazy" src={ src }/>
                {svg()}
        </div>
                
        <Slider
            getAriaLabel={() => 'Y'}
            value={valuey}
            onChange={handleChangey}
            onChangeCommitted={committed}
            orientation='vertical'
            valueLabelDisplay="auto"
            getAriaValueText={valuetext}
            disableSwap
        />
        
      </Stack>
      <Button component="label" tabIndex={-1} role={undefined} onClick={submit} 
            color={'secondary'} variant="contained" startIcon={<FileUploadIcon/>}>Submit
        </Button>
    </Box>
  );
}

export default CenterEditor;